// extracted by mini-css-extract-plugin
export default {"NavLinkClass":"HomeNavigationLink_NavLinkClass__WRx4w","activeTab":"HomeNavigationLink_activeTab__QLeC2","homeText":"HomeNavigationLink_homeText__r6Des"};